import { render } from "./NewOrderAssistance.vue?vue&type=template&id=4fdebd3f&scoped=true"
import script from "./NewOrderAssistance.vue?vue&type=script&lang=js"
export * from "./NewOrderAssistance.vue?vue&type=script&lang=js"

import "./NewOrderAssistance.vue?vue&type=style&index=0&id=4fdebd3f&lang=css"
import "./NewOrderAssistance.vue?vue&type=style&index=1&id=4fdebd3f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fdebd3f"]])

export default __exports__